<template>
  <b-container class="card-container">
    <b-card>
      Please wait you are being redirected
    </b-card>
  </b-container>
</template>

<script>

import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Billing'},
  props: ['profile'],
  data() {
    return {

    }
  },
  methods: {
    async manage_billing() {
      this.$swal({title: 'Redirecting please wait', text: "You are being redirected to the billing page, please wait", timer: 10000})
      this.$swal.showLoading()

      let response = await api.create_manage_billing_link(window.location.origin)
      this.$swal.hideLoading()
      // console.log(response)
      // window.open(response.data.url, '_blank')

      window.location.href = response.data.url

    }
  },
  mounted() {
    this.manage_billing()
  }
}
</script>

<style scoped>

</style>
